module.exports = __webpack_public_path__ + "img/202310_01_sp.83a365ba.jpg";